import React, { useState, useEffect, createContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Goal, Evaluation, getTeamGoal, deleteGoal, checkRoleEvaluation } from '../../service/PerformanceAPI';
import '../Goal/Performance.css';
import DomainName from '../OrganizationGoal/DomainName';
import { UserContext, encryptStorage } from '../../constant';
import Popup from '../../components/ConformationPopup/Popup';
import EvaluationPopUp from '../../components/EvaluationPopUp';

export default function OrganizationGoal(props) {
    const navigate = useNavigate();

    let details = { role: '', roleId: '', week: 0, domain: '' };
    const [userDetails, setUserDetails] = useState(details);
    const [Domain, setDomain] = useState([]);
    const [individualGoal, SetIndividualGoal] = useState([]);
    const [empGoal, setEmpGoal] = useState([]);
    const [eachTeamGoal, SetEachTeamGoal] = useState([]);
    const [evaluationId, setEvaluationId] = useState();
    const [popUp, setPopUp] = useState(false);
    const [goalId, setGoalId] = useState();
    const [empId, setEmpId] = useState(false);

    const [AllProgress, setAllProgress] = useState([]);
    const [teamGoal, SetTeamGoal] = useState([]);
    const [goalName, setGoalName] = useState();
    const [copyTo, setCopyTo] = useState(false);
    const [triggerEmp, setTriggerEmp] = useState(false);
    const [triggerEmpId, setTriggerEmpId] = useState();
    const [typeOfDelete, setTypeOfDelete] = useState();
    const [customStartEvaluation, setcustomStartEvaluation] = useState(false);
    const [evaluationShow, setEvaluationShow] = useState({});

    useEffect(() => {
        
        userDetails.roleId = encryptStorage.getItem('employeeId');
        //userDetails.role = encryptStorage.getItem('role');
        userDetails.domain = encryptStorage.getItem('department');
        setEvaluationId(props.evaluationPeriodId);

        loadData();
        if (props.customStartEvaluation) setcustomStartEvaluation(props.customStartEvaluation);
        if (Object.keys(props.evaluationShow).length > 0) setEvaluationShow(props.evaluationShow);
    }, [evaluationId, props.customStartEvaluation]);

    const loadData = async () => {
        let goalData = {
            role: 'Hr Manager',
            employeeId: userDetails.roleId,
            // evaluation_period_id: props.evaluationPeriodId,
            evaluation_period_id: evaluationId,
            domain: userDetails.domain,
            organizationDomain: '',
        };
        if (evaluationId) {
            
            let result = await Goal(goalData);
            setDomain(result.data.ResponseData);
        }
    };
    const DomainClicked = async () => {
        SetIndividualGoal([]);
        setEmpGoal([]);
    };

    const TeamGoalClicked = async (domain) => {
       
        let goalData = {
            team: domain,
            evaluation_period_id: props.evaluationPeriodId,
        };
        let result = await getTeamGoal(goalData);
        if (result.data.ResponseData !== null) {

            SetTeamGoal(result.data.ResponseData);
            setAllProgress(result.data.AllProgress);
        }
    };

    const IndividualClicked = async (domainName) => {
        let goalData = {
            role: 'Hr Manager',
            employeeId: userDetails.roleId,
            evaluation_period_id: props.evaluationPeriodId,
            domain: userDetails.domain,
            organizationDomain: domainName,
        };

        let result = await Goal(goalData);
        SetIndividualGoal(result.data.ResponseData);
    };

    const employeeGoals = async (empId) => {

        let goalData = {
            employeeId: empId,
            evaluation_period_id: props.evaluationPeriodId,
            domain: userDetails.domain,
        };
        let result = await Goal(goalData);

        if (empId == userDetails.roleId) {
            setEmpGoal(result.data.ResponseData.individual);
        }
    };

    const teamGoalId = async (id) => {
        let goalData = {
            teamGoalId: id,
            evaluation_period_id: props.evaluationPeriodId,
        };
        let result = await getTeamGoal(goalData);

        SetEachTeamGoal(result.data.ResponseData);
    };

    const GoalView = async (id, empId) => {
        let role;
        if (encryptStorage.getItem('employeeId') === empId) {
            role = 'Team Member';
        } else {
            let checkrole = await checkRoleEvaluation({ viewerId: encryptStorage.getItem('employeeId'), empId: empId });
            if (checkrole.data.statusCode == 200) {
                role = checkrole.data.ResponseData === 'Manager' ? checkrole.data.ResponseData : 'Hr Manager';
            }
        }
        navigate(`/goalview/${id}`, { state: { role: role } });
    };

    const EditGoal = async (id) => {
        navigate(`/goalform/${id}`);
    };

    const goalDeleteClicked = async (value) => {
        let obj = {
            goalId: goalId,
        };

        let deleteInfo = await deleteGoal(obj);
        if (deleteInfo.data.ResponseData == 'Succcesfully deleted') {
            
            setTriggerEmp(true);
            if (typeOfDelete == 'team') {
                await TeamGoalClicked(triggerEmpId);
                window.location.reload()

            } else {
                await employeeGoals(triggerEmpId);
                window.location.reload()
            }
        }
    };

    const closeCopyTo = async (value, action) => {
        
        setCopyTo(value);
        if (action) {
            await employeeGoals(triggerEmpId);
        }
    };

    return (
        <>
            <UserContext.Provider
                value={{
                    customStartEvaluation,
                    teamGoal,
                    AllProgress,
                    goalId,
                    empGoal,
                    triggerEmp,
                    triggerEmpId,
                    typeOfDelete,
                    setTypeOfDelete,
                    setTriggerEmpId,
                    setGoalId,
                    setCopyTo,
                    setTriggerEmp,
                    setGoalName,
                }}
            >
                <Popup
                    ID={'Org-Delete'}
                    deleteData={() => {
                        goalDeleteClicked();
                    }}
                />
                {copyTo ? (
                    <EvaluationPopUp
                        hide={(value, action = false) => {
                            closeCopyTo(value, action);
                        }}
                        Page={'copyto'}
                        ID={'org-Copyto'}
                        goalName={goalName}
                        GoalId={goalId}
                        EvaluationShow={props?.evaluationShow}
                    />
                ) : null}
                <div className="row mb-4">
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item border-0 accordian-table-sty">
                            {Domain !== undefined
                                ? Domain.map((eachDomain, i) => {
                                    let countTotal = parseInt(eachDomain?.individualCount) + parseInt(eachDomain?.teamCount);
                                    return (
                                        <DomainName
                                            forCount={eachDomain}
                                            countTotal={countTotal}
                                            evaluationShow={props.evaluationShow}
                                            evaluationId={props.evaluationPeriodId}
                                            index={i}
                                            domain={eachDomain.domain}
                                        />
                                    );
                                })
                                : null}
                        </div>
                    </div>
                </div>
            </UserContext.Provider>
        </>
    );
}
